import React, { Component } from "react";
import { connect } from "react-redux";
import classnames from "classnames";
import { MuiThemeProvider } from "@material-ui/core/styles";
import { Route, Redirect } from "react-router-dom";
import loadable from "react-loadable";
import LoadingComponent from "components/Loading";
import moment from "moment";
import * as authActions from "../actions/authActions";
import * as contextActions from "../actions/contextActions";

// = styles =
// 3rd
import "styles/bootstrap/bootstrap.scss";
// custom
import "styles/layout.scss";
import "styles/theme.scss";
import "styles/ui.scss";
import "styles/custom.scss";
import lightTheme from "./themes/lightTheme";
import darkTheme from "./themes/darkTheme";
import grayTheme from "./themes/grayTheme";
import { bindActionCreators } from "redux";
import { api, swal } from "../helpers";
import Loading from "./Loading";


let MainApp = loadable({
  loader: () => import("components/Layout/AppLayout/MainApp"),
  loading: LoadingComponent
});
let Exception = loadable({
  loader: () => import("routes/exception/"),
  loading: LoadingComponent
});
let Account = loadable({
  loader: () => import("routes/user/"),
  loading: LoadingComponent
});
let PageFullscreen = loadable({
  loader: () => import("routes/fullscreen/"),
  loading: LoadingComponent
});

class App extends Component {
  componentDidMount() {
    const { logout, startProcessing, stopProcessing } = this.props;
    api.startListenUserNotAuthenticated(error => {
      swal.error(error);
      logout();
    });
    api.startListenStartApiNotGet(startProcessing);
    api.startListenStopApiNotGet(stopProcessing);
    this.invalidateLoginIfExpired();
  }
  
  invalidateLoginIfExpired = ()=>{
    const { auth, logout } = this.props;
    if(auth.loggedIn){
      const expiresIn = parseInt(moment(auth.expiresIn).format("X"));
      const now = parseInt(moment().format("X"));
      if(now > expiresIn){
        logout();
      }
    }
  }

  render() {
    const {
      match,
      location,
      layoutBoxed,
      navCollapsed,
      navBehind,
      fixedHeader,
      sidebarWidth,
      theme,
      processing
    } = this.props;
    let materialUITheme;
    switch (theme) {
      case "gray":
        materialUITheme = grayTheme;
        break;
      case "dark":
        materialUITheme = darkTheme;
        break;
      default:
        materialUITheme = lightTheme;
    }

    const isRoot = location.pathname === "/" ? true : false;
    if (isRoot) {
      return <Redirect to={"/app/"} />;
    }

    return (
      <MuiThemeProvider theme={materialUITheme}>
        <div id="app-inner">
          <div className="preloaderbar hide">
            <span className="bar" />
          </div>
          <div
            className={classnames("app-main h-100", {
              "fixed-header": fixedHeader,
              "nav-collapsed": navCollapsed,
              "nav-behind": navBehind,
              "layout-boxed": layoutBoxed,
              "theme-gray": theme === "gray",
              "theme-dark": theme === "dark",
              "sidebar-sm": sidebarWidth === "small",
              "sidebar-lg": sidebarWidth === "large"
            })}
          >
            <Route path={`${match.url}app`} component={MainApp} />
            <Route path={`${match.url}exception`} component={Exception} />
            <Route path={`${match.url}user`} component={Account} />
            <Route exact path="/fullscreen" component={PageFullscreen} />
          </div>
          {processing && (
            <div className="processing-container">
              <div className="processing">
                <Loading title="Processando ..." />
              </div>
            </div>
          )}
        </div>
      </MuiThemeProvider>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  layoutBoxed: state.settings.layoutBoxed,
  navCollapsed: state.settings.navCollapsed,
  navBehind: state.settings.navBehind,
  fixedHeader: state.settings.fixedHeader,
  sidebarWidth: state.settings.sidebarWidth,
  theme: state.settings.theme,
  processing: state.context.processing,
  auth: state.auth
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      logout: authActions.logout,
      startProcessing: contextActions.startProcessing,
      stopProcessing: contextActions.stopProcessing
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(App);
